export default __webpack_public_path__ + "static/media/surgeofbile.33505fc5.png";